import React, {Component} from 'react';
import Product from './Product/Product';
import Accordion from '../Elements/DocumentAccordion/DocumentAccordion';
import Message from '../Elements/Message/Message';
import './Listview.css';
import Equalizer from 'react-equalizer';
import Headline from "../Elements/Headline/Headline";
import {ajax} from '../../Context';
import Spinner from "../Elements/Spinner/Spinner";
import LogoDisclaimer from "../Elements/LogoDisclaimer/LogoDisclaimer";

const AJAX_TYPE = '135792';

class Listview extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            category:[],
            width: window.innerWidth,
            height: window.innerHeight
        };
    }

    componentDidMount() {
        fetch(ajax.url + '?type=' + AJAX_TYPE + '&category=' + this.props.category + '&uhash=' + this.props.hash + '&w=' + this.state.width)
            .then(response => response.json())
            .then(data => this.setState({data}));
    }

    render() {
        if(typeof this.state.data === 'undefined' || this.state.data.length === 0) {
            return <Spinner message="" />;
        }else{
            if(this.state.data.message.length > 0) {
                return <Message messages={this.state.data.message} status="danger" />
            }else{
                if(this.state.data.case === 'products') {
                    let existingLogos = [];
                    if(this.state.data.existingLogos){
                        existingLogos = this.state.data.existingLogos;
                    }
                    return <div className="product-list">
                        <Headline tag="h1" label={this.state.data.category.title} brand="primary" />
                        <Equalizer>
                            {this.state.data.products.map(function(name,index){
                                return <Product product={name} key={index} productindex={index} existingLogos={existingLogos} setProduct={this.props.setProduct} setCategory={this.props.setCategory} changeRoute={this.props.changeRoute} />
                            }.bind(this))}
                        </Equalizer>
                        <div className="clearfix"></div>
                    </div>
                }else if(this.state.data.case === 'documents') {
                    var classId = "accordion" + this.state.data.id;
                    let accordions;
                    if(typeof this.state.data.categories !== 'undefined' && this.state.data.categories.length > 0) {
                        accordions = (
                            <div id={classId}>
                                {this.state.data.categories.map(function(accordion,index){
                                    return <Accordion width={this.props.width} height={this.props.height} panel={accordion} key={index} container={this.state.data.id} changeRoute={this.props.changeRoute} setFile={this.props.setFile} />
                                }.bind(this))}
                            </div>
                        )
                    }else{
                        accordions = (
                            <span className="hidden">No Documents found</span>
                        )
                    }
                    return <div>

                        <Headline tag="h1" label={this.state.data.category.title} brand="brand-default" additionalClassname="product-details--title" />

                        <div className="product-details--documents">
                            {accordions}
                        </div>
                        <LogoDisclaimer disclaimer={this.state.data.disclaimer}/>
                    </div>
                }
            }
        }

        return <div>

        </div>
    }
}

export default Listview;


// WEBPACK FOOTER //
// ./src/Components/Listview/Listview.js